module.exports = __webpack_public_path__ + "static/media/page_bg.bb5fa571.jpg";